var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2798_2588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2499 15.626L18.061 15.4594C17.5251 14.9819 17.0561 14.4344 16.6666 13.8316C16.2411 12.9997 15.9861 12.0912 15.9166 11.1594V8.41493C15.9202 6.95138 15.3893 5.53686 14.4236 4.43714C13.4579 3.33741 12.1239 2.62819 10.6721 2.44271V1.72604C10.6721 1.52934 10.594 1.34069 10.4549 1.2016C10.3158 1.06251 10.1271 0.984375 9.93045 0.984375C9.73374 0.984375 9.5451 1.06251 9.40601 1.2016C9.26692 1.34069 9.18878 1.52934 9.18878 1.72604V2.45382C7.75003 2.65267 6.4321 3.36618 5.47907 4.46221C4.52605 5.55824 4.00252 6.96251 4.00545 8.41493V11.1594C3.93587 12.0912 3.68088 12.9997 3.25545 13.8316C2.8726 14.4329 2.41111 14.9803 1.88322 15.4594L1.69434 15.626V17.1927H18.2499V15.626Z",
    fill: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.51074 17.7773C8.55946 18.1295 8.73396 18.4521 9.00201 18.6857C9.27007 18.9192 9.61357 19.0478 9.96908 19.0478C10.3246 19.0478 10.6681 18.9192 10.9361 18.6857C11.2042 18.4521 11.3787 18.1295 11.4274 17.7773H8.51074Z",
    fill: "#5B5B5B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2798_2588"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.1bf7097f8da3f73398bd097d74413a37.svg";
export { ForwardRef as ReactComponent };